module.exports = __webpack_public_path__ + "img/warning.1e6917ba.svg";